module.exports = __webpack_public_path__ + "static/media/rizzi8.687a5c27.png";